module.exports = __webpack_public_path__ + "img/a2.5675b1ee.webp";